const STORAGE_KEY = 'su_attribution';

const UTM_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const CLICK_IDS = ['gclid', 'fbclid', 'msclkid'];

/**
 * Remember how a visitor first arrived, so an enquiry can be traced to the ad
 * that paid for it.
 *
 * First touch, deliberately. Somebody clicks an ad, reads a couple of blog
 * posts over a few days, then fills in the form. Recording only the last visit
 * would credit the blog and make the ad look like it produced nothing. The
 * first campaign is kept and never overwritten by a later organic visit;
 * a *new* campaign click does replace it, because that is genuinely a new
 * campaign touch rather than the same visitor wandering the site.
 */
function read() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    return null; // private mode, or storage disabled
  }
}

function write(value) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch (err) {
    /* not fatal: the lead is still captured, just without attribution */
  }
}

/** Call once per page load, before anything reads the attribution. */
export function captureAttribution() {
  if (typeof window === 'undefined') return null;

  const params = new URLSearchParams(window.location.search);
  const incoming = {};
  [...UTM_FIELDS, ...CLICK_IDS].forEach((field) => {
    const value = params.get(field);
    if (value) incoming[field] = value.slice(0, 200);
  });

  const existing = read();
  const hasCampaign = Object.keys(incoming).length > 0;

  // Nothing new in the URL: keep whatever we already knew.
  if (!hasCampaign) {
    if (existing) return existing;
    const organic = {
      landing_page: window.location.pathname,
      first_referrer: document.referrer || undefined,
      first_seen_at: new Date().toISOString(),
    };
    write(organic);
    return organic;
  }

  const record = {
    ...incoming,
    landing_page: window.location.pathname,
    first_referrer: document.referrer || undefined,
    first_seen_at: new Date().toISOString(),
  };
  write(record);
  return record;
}

/** The stored attribution, for sending alongside a lead. */
export function getAttribution() {
  if (typeof window === 'undefined') return {};
  return read() || {};
}
